/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import type { BimWorkOrderNavData } from 'gql/graphql';
import { getLabelWorkOrder } from 'utils/getLabelWorkOrder';

import type React from 'react';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Style from './WorkOrderTitleCellHeaderComponent.module.css';

interface IWorkOrderTitleCellRendererComponent {
    workOrder: BimWorkOrderNavData;
}

export const WorkOrderTitleCellHeaderComponent: React.FC<IWorkOrderTitleCellRendererComponent> = (props) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { workOrder } = props;

    const onClick = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();

            navigate(`/projects/bim/${id}/order/${workOrder.id}`);
        },
        [id, navigate, workOrder.id],
    );

    return (
        <div className={Style.workOrderTitleCellHeader} onClick={onClick}>
            {getLabelWorkOrder(workOrder as any)}
        </div>
    );
};

WorkOrderTitleCellHeaderComponent.displayName = 'WorkOrderTitleCellHeaderComponent';
